import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'

import { Box, Flex } from '@chakra-ui/react'
import '../styles/dsr-display.scss'
import { updateDsr } from '../actions/dsr-actions'
import { redirectToNewPage } from '../../global/helpers/global-helpers'
import PageLoader from '../../global/components/helper-components/components/PageLoader'
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton'
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal'


function DsrRevertToDraftModal({ dsrId, handleCloseModal, updateDsr, updateDsrOutcome, isArchivedDsr }) {

  // UX Management
  const [showLoader, setShowLoader] = useState(false)

  useEffect(() => {
    if (updateDsrOutcome) {
      const { updateDsrStatus, sourceEvent } = updateDsrOutcome || {};

      if (updateDsrStatus && sourceEvent === "revert-dsr-to-draft") {
        redirectToNewPage(`/draft/${dsrId}`)
      }
    }

  }, [updateDsrOutcome, dsrId]);

  const handleClickUnpublishButton = () => {
    setShowLoader(true);
    updateDsr({ dsrId, status: 'reverted-draft', sourceEvent: "revert-dsr-to-draft" })
  }

  function displayContent() {
    if (showLoader) {
      return (
        <Box w="100%" align="center" >
          <Box px='1em'>
            <Box>
              <PageLoader />
            </Box>
          </Box>
        </Box>
      )
    }

    if (!showLoader) {

      if (isArchivedDsr) {
        return (
          <Flex justify='flex-start' px='1.5em' w='100%'>
            <Box w='100%'>
              <Box w="100%" my="1em" color='brandDark.500'>
                <Box fontSize='0.875em'>
                  The Room will be unarchived & revert to being a draft.
                </Box>
                <Box fontSize='0.875em' mt='0.875em'>
                  Proceed?
                </Box>
              </Box>

              <Flex w='100%' mt='1em'>
                <Flex my='0.625em' justify='flex-end' w='100%'>
                  <LaunchdeckButton bg='gray.700' color='white' onClick={() => handleClickUnpublishButton()} label='Yes, unarchive it' />
                </Flex>
              </Flex>
            </Box>
          </Flex>
        )
      }
      return (
        <Flex justify='flex-start' px='1.5em' mt='1em' w='100%'>
          <Box w='100%'>

            <Box w="100%" my="1em" color='brandDark.500'>

              <Box fontSize='0.875em'>
                The Room will revert to its draft state, and all content will remain as it is. Members will be unable to view the Room.
              </Box>
              <Box fontSize='0.875em' mt='0.875em'>
                Proceed?
              </Box>
            </Box>

            <Flex w='100%' mt='1em'>
              <Flex my='0.625em' justify='flex-end' w='100%'>
                <LaunchdeckButton bg='gray.700' color='white' onClick={() => handleClickUnpublishButton()} label='Unpublish' />

              </Flex>
            </Flex>
          </Box>


        </Flex>
      )
    }
  }

  return (
    <LaunchdeckModal
      title={isArchivedDsr ? `You are about to unarchive this Room` : `You are about to unpublish this Room`}
      handleCloseModal={handleCloseModal}
      showModal={true}
      maxW='45em'
    >

      {displayContent()}
    </LaunchdeckModal>

  )
}

function mapStateToProps(state) {
  return {
    updateDsrOutcome: state.updateDsrOutcome.results.data,
    isArchivedDsr: state.isArchivedDsr.results
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateDsr
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrRevertToDraftModal));
